import { render, staticRenderFns } from "./manuals.vue?vue&type=template&id=1c6a7d08&"
import script from "./manuals.vue?vue&type=script&lang=js&"
export * from "./manuals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports